import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import VipLevelsAPI from '../../api/vipLevels';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isDeleting: false,
  },
};

export const getters = {
  getVipLevels(_state) {
    return _state.records;
  },
  getActiveVipLevels(_state) {
    return _state.records.filter(level => level.active);
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getVipLevel: _state => levelId => {
    return _state.records.find(record => record.id === Number(levelId));
  },
};

export const actions = {
  get: async ({ commit }) => {
    commit(types.SET_VIP_LEVELS_UI_FLAG, { isFetching: true });
    try {
      const response = await VipLevelsAPI.get();
      commit(types.SET_VIP_LEVELS, response.data.payload.vip_levels);
      return true;
    } catch (error) {
      return false;
    } finally {
      commit(types.SET_VIP_LEVELS_UI_FLAG, { isFetching: false });
    }
  },

  create: async ({ commit }, vipLevelObj) => {
    commit(types.SET_VIP_LEVELS_UI_FLAG, { isCreating: true });
    try {
      const response = await VipLevelsAPI.create(vipLevelObj);
      commit(types.ADD_VIP_LEVEL, response.data);
      return response.data;
    } catch (error) {
      throw error;
    } finally {
      commit(types.SET_VIP_LEVELS_UI_FLAG, { isCreating: false });
    }
  },

  update: async ({ commit }, payload) => {
    commit(types.SET_VIP_LEVELS_UI_FLAG, { isUpdating: true });
    try {
      const { id, vip_level } = payload;
      const response = await VipLevelsAPI.update(id, { vip_level });
      commit(types.EDIT_VIP_LEVEL, response.data);
      return response.data;
    } catch (error) {
      throw error;
    } finally {
      commit(types.SET_VIP_LEVELS_UI_FLAG, { isUpdating: false });
    }
  },

  delete: async ({ commit }, id) => {
    commit(types.SET_VIP_LEVELS_UI_FLAG, { isDeleting: true });
    try {
      await VipLevelsAPI.delete(id);
      commit(types.DELETE_VIP_LEVEL, id);
    } catch (error) {
      throw error;
    } finally {
      commit(types.SET_VIP_LEVELS_UI_FLAG, { isDeleting: false });
    }
  },

  bulkCreate: async ({ commit }, vipLevels) => {
    commit(types.SET_VIP_LEVELS_UI_FLAG, { isCreating: true });
    try {
      const response = await VipLevelsAPI.bulkCreate(vipLevels);
      commit(types.SET_VIP_LEVELS, response.data.vip_levels);
      return response.data.vip_levels;
    } catch (error) {
      throw error;
    } finally {
      commit(types.SET_VIP_LEVELS_UI_FLAG, { isCreating: false });
    }
  },
};

export const mutations = {
  [types.SET_VIP_LEVELS_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },

  [types.SET_VIP_LEVELS]: MutationHelpers.set,
  [types.ADD_VIP_LEVEL]: MutationHelpers.create,
  [types.EDIT_VIP_LEVEL]: MutationHelpers.update,
  [types.DELETE_VIP_LEVEL]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
